//WATCH-POINTS
export const FETCH_USER_TODAYS_POINTS = "fetchpoints";
export const UPDATE_USER_LOCAL_POINTS = "updatelocpoints";
